import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import type { IFailedOrdersContextValue } from './types';

export default createContext<IFailedOrdersContextValue>({
  state: initialState,
  actions: initialActionsState,
});
